import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const contentPrimary = '#001464';
const contentSecondary = '#001443';
const blue300 = '#B4D4F8';

const ProductDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: 16px 0px 0px 0px;
  ${({ firstItem }) => (firstItem
        ? `
    padding: 8px 0px 0px 0px;
  `
        : `
  padding: 16px 0px 0px 0px;
`)}
`;
const ProductDetailTitle = styled.label`
  color: ${contentPrimary};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  align-self: stretch;
`;
const ProductDetailSubTitle = styled.label`
  color: ${contentSecondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
  align-self: stretch;
`;

const ProductList = styled.ul`
  list-style: disc;
  padding-left: 20px;
  width: 100%;
`;

const ProductItem = styled.li`
  color: ${contentSecondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
`;

const ProductDetailbulletPointContainer = styled.div`
  display: flex;
  padding: 0px 0px 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  ${({ showBottom }) => showBottom
    && `
    border-bottom: 1px solid ${blue300};
  `}
`;

const ProductReferToPDS = styled.label`
  color: #001443;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
`;

const ProductReadMore = styled.div`
  cursor: pointer;
  color: #0F58AB;
`;

/**
 * Function for rendering product details.
 *
 * @param {object} props - the properties object
 * @return {JSX.Element} the rendered product details component
 */

const _ProductDetails = (props) => {
    const {
        title,
        subTitle,
        details,
        paragraph,
        footerText,
        showBottom = true,
        firstItem = true,
        readMore = '',
        openModal
    } = props;

    const readMoreOnClicked = () => {
        openModal();
    };

    return (
        <ProductDetailContainer firstItem={firstItem}>
            <ProductDetailbulletPointContainer showBottom={showBottom}>
                <ProductDetailTitle>{title}</ProductDetailTitle>
                {subTitle && <ProductDetailSubTitle>{subTitle}</ProductDetailSubTitle>}
                {details.length === 0 ? <ProductReferToPDS>Refer to PDS</ProductReferToPDS> : (
                    <ProductList>
                        {details.map((detail, index) => (
                            index === 0
                                ? (
                                    <ProductItem key={`product-item-${index}`}>
                                        {detail}
                                        {' '}
                                        {readMore !== '' && (
                                            <>
                                                <ProductReadMore onClick={readMoreOnClicked}>Read more</ProductReadMore>
                                            </>
                                        )}
                                    </ProductItem>
                                )
                                : <ProductItem key={`product-item-${index}`}>{detail}</ProductItem>
                        ))}
                    </ProductList>
                )}
                {paragraph && <ProductDetailSubTitle>{paragraph}</ProductDetailSubTitle>}
                {footerText && (<ProductDetailSubTitle>{footerText}</ProductDetailSubTitle>)}
            </ProductDetailbulletPointContainer>
        </ProductDetailContainer>
    );
};

_ProductDetails.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    details: PropTypes.array.isRequired,
    paragraph: PropTypes.string,
    footerText: PropTypes.string,
    showBottom: PropTypes.bool,
    readMore: PropTypes.string,
    openModal: PropTypes.func
};

/**
 * mapStateToProps - sets up the rules required by this component
 * @param {Object} dispatch - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */

const mapDispatchToProps = (dispatch) => ({
    openModal: () => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: '11MonthsSpecialConditionReadMoreOpen',
            value: true
        });
    }
});

const mapStateToProps = (state, item) => {
};

const ProductDetails = connect(mapStateToProps, mapDispatchToProps)(_ProductDetails);

export { _ProductDetails, ProductDetails };
